/**
 * Site speed (2026-10-08): wagmi's autoConnect calls isAuthorized() on every connector at each cold load, and some
 * connectors answer by downloading their wallet SDK first. This makes such a connector answer "not authorized" without
 * loading anything unless it was the last connector used on this device; then the original check runs unchanged.
 */
export function authorizeOnlyWhenLastUsed<C extends { id: string; isAuthorized: () => Promise<boolean> }>(
  connector: C,
  lastUsed: () => string | null | undefined,
): C {
  const original = connector.isAuthorized.bind(connector)
  // eslint-disable-next-line no-param-reassign
  connector.isAuthorized = () => (lastUsed() === connector.id ? original() : Promise.resolve(false))
  return connector
}
